// extracted by mini-css-extract-plugin
export default {"logo":"SiteHeader_logo__POOFl"};